// extracted by mini-css-extract-plugin
export default {"sortableList":"SortableList_sortableList__Tbv8y","dropPlaceholder":"SortableList_dropPlaceholder__svoDR","item":"SortableList_item__ZWIx8","grab":"SortableList_grab__FJKkR"};